export var formatNumericUserDate = function (date, locale, includeWeekday) {
    if (includeWeekday === void 0) { includeWeekday = false; }
    return new Intl.DateTimeFormat(locale, {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        weekday: includeWeekday ? 'long' : undefined,
    })
        .format(date)
        .replace(/ /g, '\xA0');
};
